const riskLevelMap = [
    {
        level: '激进冒险型',
        nickName: '金刚钻型金融玩家',
        text: '您在权益类资产上的配比权重过大，在市场波动加大时会承受较高风险，普通投资者的择时能力较弱，建议降低该资产的配比权重,'
    }, {
        level: '防守为先型',
        nickName: '强盾魔王型金融玩家',
        text: '您在风险控制上做的较为出色，资产配置方向以防守为主。防守型策略如果配上一些专业的择时能力能够有效的增强收益,'
    }, {
        level: '稳健投资型',
        nickName: '翩翩侠客型金融玩家',
        text: '您在整体配置上比较平衡，属于中等风险偏好类型,'
    }
]

export default riskLevelMap; 